import { updateSetting } from '@/vuex/modules/user-settings/user-settings.utils';
import moment from '@/utils/moment-wrapper.ts';
import Vue from 'vue';
import { HISTORY_KEYS, MAX_TYPE_HISTORY, RECENTLY_SELECTED_HISTORY_TYPES } from './history.constants';
import { AI_AGENT_ICON_TYPE } from '@/ai-agents/components/ai-agents.constants.js';

const history = {
    namespaced: true,
    state: {
        map: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setItemHistory (state, { type, itemHistory }) {
            Vue.set(state.map, type, itemHistory);
        },
    },
    actions: {
        async updateMostRecent ({ dispatch }, { id, type, maxHistory = MAX_TYPE_HISTORY }) {
            if (!id) {
                return;
            }
            await dispatch('updateBatchMostRecent', { ids: [id], type, maxHistory });
        },
        async updateBatchMostRecent ({ commit, getters, rootState }, { ids, type, maxHistory = MAX_TYPE_HISTORY }) {
            const { active: subscription } = rootState.subscription;
            const settingName = `${type}--${subscription.id}`;

            let itemHistory = getters.itemHistory(type).filter((item) => !ids.includes(item.id));

            ids.forEach((id) => {
                if (id) {
                    itemHistory.unshift({
                        id,
                        timestamp: moment().valueOf(),
                    });
                }
            });

            if (itemHistory.length > maxHistory) {
                itemHistory = itemHistory.slice(0, maxHistory);
            }

            const updatedSetting = await updateSetting({
                name: settingName,
                value: JSON.stringify(itemHistory),
                userId: '{{uid}}',
            });

            commit('setItemHistory', { type, itemHistory: JSON.parse(updatedSetting.value) });
        },
        setHistory ({ commit }, { history }) {
            commit('setMap', { map: history });
        },
    },
    getters: {
        itemHistory: (state) => (type) => {
            return state.map[type] || [];
        },
        allItemHistory: (state) => (types = []) => {
            return Object.keys(state.map)
                .filter((key) => {
                    if (!types.length) {
                        return true;
                    }

                    return types.includes(key);
                })
                .flatMap((key) => {
                    return state.map[key].map((item) => ({
                        ...item,
                        type: HISTORY_KEYS[key] || RECENTLY_SELECTED_HISTORY_TYPES[key],
                    }));
                })
                .sort((a, b) => b.timestamp - a.timestamp);
        },
        getRecentAgentEvents: (state, getters, rootState, rootGetters) => (aiAgentsMap) => {
            return getters.itemHistory(RECENTLY_SELECTED_HISTORY_TYPES.AGENT_RECENTLY_SELECTED)
                .filter(({ id }) => aiAgentsMap[id])
                .map(({ id, timestamp }) => {
                    const agent = aiAgentsMap[id];
                    const app = rootGetters['apps/getAppById'](agent.appId);

                    return {
                        id: agent.id,
                        name: agent.name,
                        group: agent.group,
                        appId: agent.appId,
                        appIcon: rootGetters['apps/getIconByAppId'](agent.appId),
                        appDisplayName: app ? app.displayName : undefined,
                        kind: agent.kind,
                        dirty: agent.dirty,
                        isCoreEvent: agent.isCoreEvent,
                        isStarred: !!rootGetters['stars/getStarByItemId'](agent.id),
                        icon: agent.icon || { type: AI_AGENT_ICON_TYPE },
                        lastUsed: timestamp,
                    };
                });
        },
    },
};

export default history;
